<template>
  <div class="welcome-wrapper">
    <div class="welcome-content">
      <h1 class="welcome-title">
        Bienvenido a
        <span class="brand">XperienceIQ</span>
      </h1>
      <p class="welcome-subtitle">
        Tu ecosistema digital para gestión clínica
      </p>

      <div class="action-buttons">
        <router-link
          to="/xperienceiq/dashboard-client"
          class="btn-primary"
        >
          Ir al Dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeView'
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap');

.welcome-wrapper {
  font-family: 'Montserrat', sans-serif;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-principal, #1a1a1a);
  color: var(--color-texto-aside, #fff);
  text-align: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.welcome-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    var(--color-principal, #1a1a1a) 0%,
    var(--color-secundario, #000) 50%,
    var(--color-detalles, #333) 100%
  );
  opacity: 0.9;
  z-index: 0;
}

.welcome-content {
  max-width: 700px;
  animation: fadeIn 1s ease-in;
  position: relative;
  z-index: 1;
}

.welcome-title {
  font-size: 3rem;
  font-weight: 300;
  margin-bottom: 1rem;
  line-height: 1.3;
  color: var(--color-texto-aside, #fff);
}

.brand {
  display: block;
  font-weight: 700;
  font-size: 3.5rem;
  background: linear-gradient(to right,
    var(--color-texto-aside, #fff),
    var(--color-detalles, #888)
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 0.5rem;
}

.welcome-subtitle {
  font-size: 1.2rem;
  color: var(--color-texto-secundario, #888);
  font-weight: 300;
  margin-bottom: 3rem;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-primary {
  padding: 1rem 2.5rem;
  background: var(--color-card-fondo, #fff);
  color: var(--color-texto-principal, #000);
  text-decoration: none;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  border: 2px solid var(--color-detalles, #fff);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background: var(--color-detalles, #f0f0f0);
  border-color: var(--color-texto-aside, #fff);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .welcome-wrapper {
    padding: 1rem;
    padding-top: 4rem; /* Space for mobile menu button */
  }

  .welcome-title {
    font-size: 2rem;
  }

  .brand {
    font-size: 2.5rem;
  }

  .welcome-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .btn-primary {
    padding: 0.875rem 2rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .welcome-wrapper {
    padding: 0.75rem;
    padding-top: 4rem;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .brand {
    font-size: 2rem;
  }

  .welcome-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }

  .btn-primary {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
    width: 100%;
    max-width: 280px;
  }
}
</style>
